<div class="recap-care-manager-container">
  <div>
    <img src="/public/assets/images/two-hand-heart.png" alt="two-hand-heart-image" />
  </div>
  <div>
    <div class="header">
      <p class="title">{{ 'steps.recapCareManager.title' | translate }}</p>
      <p class="subtitle">{{ 'steps.recapCareManager.subtitle' | translate }}</p>
    </div>
    <div class="header">
      <p class="second-title">{{ 'steps.recapCareManager.whoIs' | translate }}</p>
      <nz-divider></nz-divider>
      <p class="second-subtitle">{{ 'steps.recapCareManager.whoIsTxt' | translate }}</p>
    </div>
    <div class="header">
      <p class="second-title">{{ 'steps.recapCareManager.whatHeDoes' | translate }}</p>
      <nz-divider></nz-divider>
      <p class="second-subtitle">{{ 'steps.recapCareManager.whatHeDoesTxtOne' | translate }}</p>
      <p class="third-subtitle">{{ 'steps.recapCareManager.whatHeDoesTxtTwo' | translate }}</p>
    </div>
    <div class="checkbox">
      <label nz-checkbox (click)="setValue()"> Non mostrare più. </label>
    </div>
  </div>
</div>
